export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_lemon_p.3c5846da.jpg";